export default "__VITE_ASSET__eaf8c325__"